"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mixins = require("../mixins");
var _excluded = ["src", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Avatar image url */
  src: _propTypes["default"].string,
  /** Text or something else to be displayed, passed as children */
  children: _propTypes["default"].string,
  /** Width and height of the avatar. Will default to 30px */
  w: _propTypes["default"].string
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Avatar__Wrapper",
  componentId: "sc-he8nuf-0"
})(["", ";", ";position:relative;width:", ";height:", ";border-radius:50%;overflow:hidden;> img{display:block;width:100%;height:auto;}"], (0, _mixins.backgroundMixin)("textSecondary"), (0, _mixins.colorMixin)("textInverted"), function (props) {
  return props.w || "30px";
}, function (props) {
  return props.w || "30px";
});
Wrapper.displayName = "AvatarWrapper_SC";
var Avatar = function Avatar(_ref) {
  var src = _ref.src,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, rest, src ? /*#__PURE__*/_react["default"].createElement("img", {
    src: src,
    alt: "User Avatar"
  }) : {
    children: children
  });
};
Avatar.propTypes = propTypes;
var _default = Avatar;
exports["default"] = _default;